import React from "react";
import "./SmallCircle.css";

function SmallCircle() {
  return <div className="small-circle"></div>;
}

export default SmallCircle;
